import jsCookie from 'js-cookie'

/**
 * @description 缓存设置
 * @param key 键名
 * @param value 键值
 */
export function setCache(cacheMode, key, value) {
  switch (cacheMode) {
    case 'cookie':
      jsCookie.set(key, value, { expires: 1 }) // cookie有效期为1天
      break
    case 'sessionStorage':
      sessionStorage.setItem(key, value)
      break
    case 'localStorage':
      localStorage.setItem(key, value)
      break
    default:
      jsCookie.set(key, value, { expires: 1 }) // cookie有效期为1天
      break
  }
}

/**
 * @description 缓存读取
 * @param key 键名
 */
export function getCache(cacheMode, key) {
  let value = undefined
  switch (cacheMode) {
    case 'cookie':
      value = jsCookie.get(key)
      break
    case 'localStorage':
      value = localStorage.getItem(key)
      break
    case 'sessionStorage':
      value = sessionStorage.getItem(key)
      break
    default:
      value = jsCookie.get(key)
      break
  }
  return value
}

/**
 * @description 移除缓存
 * @param key 键名
 */
export function removeCache(cacheMode, key) {
  switch (cacheMode) {
    case 'cookie':
      jsCookie.remove(key)
      break
    case 'localStorage':
      localStorage.removeItem(key)
      break
    case 'sessionStorage':
      sessionStorage.removeItem(key)
      break
    default:
      jsCookie.remove(key)
      break
  }
}
